import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import TitleCard from '../../../components/TitleCard/TitleCard';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';

const DepartmentsCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const editingDepartment = location.state?.department || null;

    const [formData, setFormData] = useState({
        code: '',
        description: '',
        active: true
    });

    const [isSubmitting, setIsSubmitting] = useState(false); // estado para el submit

    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmData, setConfirmData] = useState({
        title: '',
        message: '',
        type: 'info',
    });

    useEffect(() => {
        if (editingDepartment) {
            setFormData({
                description: editingDepartment.description || '',
                code: editingDepartment.code || '',
                active: editingDepartment.active

            });
        }
    }, [editingDepartment]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // 🔹 deshabilita el botón

        try {
            const token = localStorage.getItem('access_token');

            if (editingDepartment) {
                await axios.put(
                    `${process.env.REACT_APP_API_URL}/department/update/${editingDepartment._id}`,
                    formData,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setConfirmData({
                    title: 'Departamento actualizado',
                    message: `El departamento "${formData.description}" fue actualizado exitosamente.`,
                    type: 'success',
                });
            } else {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/department/create`,
                    formData,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setConfirmData({
                    title: 'Departamento creado',
                    message: `El departamento "${formData.description}" fue creado exitosamente.`,
                    type: 'success',
                });
            }

            setShowConfirm(true);
        } catch (err) {
            console.error('Error guardando departamento:', err);
            setConfirmData({
                title: 'Error',
                message: err.response?.data?.message || 'No se pudo guardar el departamento. Intenta nuevamente.',
                type: 'error',
            });
            setShowConfirm(true);
        }
    };

    const handleConfirm = () => {
        setShowConfirm(false);
        setIsSubmitting(false); // 🔹 habilita el botón nuevamente

        if (confirmData.type === 'success') {
            navigate('../masters/departments-list');
        }
    };

    return (
        <>
            <TitleCard title={editingDepartment ? 'Editar Departamento' : 'Crear Departamento'} />
            <form onSubmit={handleSubmit} className="bg-white px-6 py-6 mt-4 rounded-lg shadow-md grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
                <div className="flex flex-col">
                    <label htmlFor="code">Código:</label>
                    <input
                        type="text"
                        id="code"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                        required
                    />
                </div>
                <div className="flex flex-col">
                    <label htmlFor="description">Descripción:</label>
                    <input
                        type="text"
                        id="description"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                        required
                    />
                </div>
                    <div className="flex items-center gap-4 mt-2">

                        <label htmlFor="active" className="text-gray-600 font-normal">
                            Estado:
                        </label>

                        <button type="button" className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 ${formData.active ? "bg-blue-600" : "bg-gray-300"}`}
                            onClick={() =>
                                setFormData(prev => ({
                                    ...prev,
                                    active: !prev.active
                                }))
                            }
                        >
                            <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 ${formData.active ? "translate-x-8" : "translate-x-1"}`} />
                        </button>

                        <span className="text-sm text-gray-500">
                            {formData.active ? "Activo" : "Inactivo"}
                        </span>

                    </div>
                {/* Botones - ocupan 2 columnas */}
                <div className="flex gap-2 mt-4">
                    <GradientButton
                        type="submit"
                        disabled={isSubmitting}
                    >
                        {isSubmitting
                            ? (editingDepartment ? 'Actualizando...' : 'Creando...')
                            : (editingDepartment ? 'Guardar' : 'Aceptar')}
                    </GradientButton>
                    <CancelButton onClick={() => navigate(-1)} />
                </div>
            </form>

            <ConfirmModal
                isOpen={showConfirm}
                title={confirmData.title}
                message={confirmData.message}
                type={confirmData.type}
                onConfirm={handleConfirm}
                onClose={() => setShowConfirm(false)}
            />
        </>
    );

}

export default DepartmentsCreate;